<app-side-bar></app-side-bar>
<!--Navbar-->
<div class="grid navbar">
    <div class="col-12">
        <app-navbar (paramDialog)="handleParamDialog($event)"
                    (actionLogging)="handleOpenActionLogging($event)"
                    (downloadVirtualPrinter)="handleVirtualPrinter($event)"></app-navbar>
    </div>
</div>
<div class="grid">
    <div class="nav-bar-separator"></div>
</div>
<!--Content-->
<div class="grid main-container"
     appDnd (filesChangeEmitter)="onFilesChange($event)"
     (filesInvalidEmitter)="onFileInvalids($event)"
     (dragFileEmitter)="enableUploadModal($event)"
     [allowedExtensions]="['pdf', 'doc', 'txt']">

    <!--Left Container-->
    <div *ngIf="displayTracking" class="col-3 left-pannel">
        <app-left-container (displayUserManagementEvent)="showUserManagement($event)"
                            (upload)="handleOpenModal($event)" (modalTitleExpress)="updateExpressDialogTitle($event)"></app-left-container>
    </div>

    <!--Right Container-->
    <div *ngIf="displayTracking" class="col-9 right-pannel">
        <app-right-container [displayUserManagement]="displayUserManagement"></app-right-container>
    </div>
    <div *ngIf="!displayTracking" class="col-12 upload-screen">
        <app-upload [kindOfUpload]="kindOfUpload" [visibleModal]="displayUpload"
                    (modalDisplay)="handleCloseModal($event)">
        </app-upload>
    </div>
</div>

<!--Configuration modal-->
<div *ngIf="displayConfig" class="configModal">
    <p-dialog [(visible)]="displayConfig"
              [header]="'APPLICATION.CONTAINER_COMPONENT.MODAL_CONFIGURATION_HEADER' | translate" [draggable]="false"
              [closable]="true"
              [resizable]="true"
              [modal]="true" [closeOnEscape]="true">
        <app-configuration (impersonateEnd)="handleParamDialog($event)"></app-configuration>
    </p-dialog>
</div>

<!--Download Virtual Printer modal-->
<div *ngIf="displayVirtualPrinterModal" class="configModal">
    <p-dialog [(visible)]="displayVirtualPrinterModal" [draggable]="false"
              [closable]="false"
              [resizable]="true"
              [modal]="true" [closeOnEscape]="true"
              [style]="{overflowY: 'auto'}">
        <ng-template pTemplate="header">
            <div class="col-12">
                <div class="col-8" style="float:left;">
                <h3>{{'APPLICATION.CONTAINER_COMPONENT.MODAL_VIRTUAL_PRINTER' | translate}}</h3>
                </div>
                <div class="col-4" style="float:right;">
                    <button *ngIf="this.user.admin && !this.displayUploadVirtualPrinterPanel"
                            pButton type="button"
                            [label]="'Nouveau Package'"
                            title="Uploader une nouvelle version de l'imprimante virtuelle"
                            (click)="this.displayUploadVirtualPrinterPanel = !this.displayUploadVirtualPrinterPanel"
                            icon="fa fa-plus"></button>
                    <button pButton type="button"
                            [label]=""
                            style="float:right;margin-left: 2px;"
                            (click)="closeVirtualPrinterModal()" icon="fa fa-close"></button>

                </div>
            </div>

        </ng-template>

        <app-virtual-printer [displayUploadVirtualPrinterPanel]="displayUploadVirtualPrinterPanel"
                             (maskUploadVirtualPrinterPanel)="this.displayUploadVirtualPrinterPanel = !this.displayUploadVirtualPrinterPanel"></app-virtual-printer>
    </p-dialog>
</div>

<div *ngIf="displayActionLogging" class="configModal">
  <p-dialog [(visible)]="displayActionLogging" [draggable]="false"
            [closable]="false"
            [resizable]="true"
            [modal]="true" [closeOnEscape]="true"
            [style]="{overflowY: 'auto'}">
    <ng-template pTemplate="header">
      <div class="col-12">
        <div class="col-8" style="float:left;">
          <h3>{{'APPLICATION.CONTAINER_COMPONENT.MODAL_EVENTS_LOGGING' | translate}}</h3>
        </div>
        <div class="col-4" style="float:right;">
          <button pButton type="button"
                  [label]=""
                  style="float:right;margin-left: 2px;"
                  (click)="closeActionLoggingModal()" icon="fa fa-close"></button>
        </div>
      </div>
    </ng-template>

    <app-action-logging></app-action-logging>

  </p-dialog>
</div>

<!--upload files modal-->
<div *ngIf="displayTracking" id="upload">
    <div *ngIf="displayUpload" id="standard">
        <div class="uploadModal">
            <p-dialog [(visible)]="displayUpload" [header]="modalTitle" [draggable]="false"
                      [closable]="true"
                      [resizable]="false"
                      [modal]="true" [closeOnEscape]="false" (onHide)="closeUpload()">
                <app-upload [kindOfUpload]="kindOfUpload" [visibleModal]="displayUpload"
                            (modalDisplay)="handleCloseModal($event)">
                </app-upload>
            </p-dialog>
        </div>
    </div>
    <div *ngIf="displayUploadExpress" id="express">
        <div class="express-upload-modal">
            <p-dialog [(visible)]="displayUploadExpress" [header]="modalTitleExpress" [draggable]="false"
                      [closable]="true"
                      [resizable]="false" [focusTrap]="false"
                      [modal]="true" [closeOnEscape]="false" (onHide)="closeUpload()">
                <!--<app-express-upload (modalDisplay)="handleCloseModalExpress($event)"></app-express-upload>-->
                <app-express-deposit (modalDisplay)="handleCloseModalExpress($event)" (selectedTypeChanged)="updateExpressDialogTitle($event)"></app-express-deposit>
            </p-dialog>
        </div>
    </div>
</div>


